// TermsPage.jsx
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import { fetchTermsOfService } from "../../services/LegalService"; // import serwisu
import "./TermsPage.css";
import {useTranslation} from "react-i18next";

const TermsPage = () => {
  const [termsData, setTermsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {t, i18n} = useTranslation();

  useEffect(() => {
    const loadTerms = async () => {
      try {
        const data = await fetchTermsOfService(i18n.resolvedLanguage || "en");
        setTermsData(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, []);

  if (loading) {
    return (
      <main className="terms-page">
        <PageHeader title={"Terms and Conditions"} />
        <div className="terms-container">Loading...</div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="terms-page">
        <PageHeader title={"Terms and Conditions"}/>
        <div className="terms-container">{error}</div>
      </main>
    );
  }

  return (
    <main className="terms-page">
      <PageHeader title={"Terms and Conditions"}/>
      <div className="terms-container">
        {/* INTRO */}
        {/* {termsData[0]?.header && (
          <div className="terms-intro">
            <h1>{termsData[0].header}</h1>
            {termsData[0].steps.map((step, idx) => (
              <h3 key={idx}>{step}</h3>
            ))}
          </div>
        )} */}

        {/* SEKCJE */}
        {termsData.slice(1).map((section, idx) => (
          <section key={idx} className="terms-section">
            <h2
              id={
                section.header === "ART. 17 – UNLIMITED DATA PLANS (Fair Usage Policy)" ? "art-17-unlimited" : undefined
              }
            >
              {section.header}
            </h2>

            {section.steps.map((step, stepIdx) => (
              <p key={stepIdx} className="terms-paragraph">
                {step}
              </p>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
};

export default TermsPage;
